import React, { useState, useEffect } from 'react'
import { getSenderPic } from '../../../ChatLogics'

function ProfilePreview({ chat, loggedUser }) {
  return (
    <>
      {chat.isGroupChat === true ? (
        <div
          class="modal fade dialogbox"
          id="DialogImage1"
          // data-bs-backdrop="static"
          tabindex="-1"
          role="dialog"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <img
                // src="assets/img/sample/photo/1.jpg"
                src={getSenderPic(loggedUser, chat.users)}
                alt="image"
                class="img-fluid"
              />
              <div class="modal-footer">
                <div class="btn-inline">
                  <a
                    href="#"
                    class="btn btn-text-secondary"
                    data-bs-dismiss="modal"
                  >
                    CLOSE
                  </a>
                  <a
                    href="#"
                    class="btn btn-text-primary"
                    data-bs-dismiss="modal"
                  >
                    SHARE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {chat.users.some(v => v.type === 'bot') ? (
            <div
              class="modal fade dialogbox"
              id="DialogImage2"
              // data-bs-backdrop="static"
              tabindex="-1"
              role="dialog"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <img
                    src="assets/img/sample/photo/1.jpg"
                    // src={getSenderPic(loggedUser, chat.users)}
                    alt="image"
                    class="img-fluid"
                  />
                  <div class="modal-footer">
                    <div class="btn-inline">
                      <a
                        href="#"
                        class="btn btn-text-secondary"
                        data-bs-dismiss="modal"
                      >
                        CLOSE
                      </a>
                      <a
                        href="#"
                        class="btn btn-text-primary"
                        data-bs-dismiss="modal"
                      >
                        SHARE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              class="modal fade dialogbox"
              id="DialogImage3"
              // data-bs-backdrop="static"
              tabindex="-1"
              role="dialog"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <img
                    // src="assets/img/sample/photo/1.jpg"
                    src={getSenderPic(loggedUser, chat.users)}
                    alt="image"
                    class="img-fluid"
                  />
                  <div class="modal-footer">
                    <div class="btn-inline">
                      <a
                        href="#"
                        class="btn btn-text-secondary"
                        data-bs-dismiss="modal"
                      >
                        CLOSE
                      </a>
                      <a
                        href="#"
                        class="btn btn-text-primary"
                        data-bs-dismiss="modal"
                      >
                        SHARE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <div
        class="modal fade dialogbox"
        id="DialogImage"
        // data-bs-backdrop="static"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <img
              // src="assets/img/sample/photo/1.jpg"
              src={getSenderPic(loggedUser, chat.users)}
              alt="image"
              class="img-fluid"
            />
            <div class="modal-footer">
              <div class="btn-inline">
                <a
                  href="#"
                  class="btn btn-text-secondary"
                  data-bs-dismiss="modal"
                >
                  CLOSE
                </a>
                <a
                  href="#"
                  class="btn btn-text-primary"
                  data-bs-dismiss="modal"
                >
                  SHARE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfilePreview
